import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';
import { Link } from 'react-router';
import shallowEqual from 'react-pure-render/shallowEqual';
import has from 'lodash/has';
import findIndex from 'lodash/findIndex';
import moment from 'moment';

import { setHeader, loadPageView } from 'actions';

import Icon from 'components/common/Icon';
import Loading from 'components/common/Loading';
import EventList from 'components/calendar/EventList';
import EventListItem from 'components/calendar/EventListItem';

class PageViewPage extends Component {
  static loadData(props) {
    const { page_id } = props;

    props.loadPageView(page_id);
  }

  constructor(props) {
    super(props);

    this.state = {
      showShare: props.showShare || false,
    };

    this.toggleShare = this.toggleShare.bind(this);
    this.renderEventListItem = this.renderEventListItem.bind(this);
  }

  componentWillMount() {
    PageViewPage.loadData(this.props);
    this.updateHeader(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.page_id && nextProps.page_id !== this.props.page_id) {
      PageViewPage.loadData(nextProps);
    }

    const currentPage = has(this.props, 'page_details') ? this.props.page_details : [];
    const pageChanged = (has(nextProps, 'page_details') && !shallowEqual(nextProps.page_details, currentPage));

    if (pageChanged) {
      this.updateHeader(nextProps);
    }
  }

  toggleShare() {
    this.setState({ showShare: !this.state.showShare }, () => {
      // this.props.setPageListSearch(this.state.searchTerm);
    });
  }

  updateHeader(props) {
    /*if(has(props, 'page_details.name')) {
      const page_details = props.page_details;

      props.setHeader(page_details.name, '/page', 'Pages');
    } else {
      props.setHeader('Page', '/page', 'Pages');
    }*/

    // const shareIcon = (<Icon icon="share" size="medium" clickable onClick={() => this.toggleShare()} />);
    let shareIcon;

    props.setHeader('Page Details', '/page', 'Pages', shareIcon);
  }

  renderEventListItem(event, drawDivider = false) {
    return (
      <EventListItem
        drawDivider={drawDivider}
        showChevron
        event={event}
        key={`${event.date}_${event.id}`}
        onSelect={selectedEvent => this.props.push(`/calendar/details/${selectedEvent.id}`)}
      />
   );
  }

  render() {
    const { page_id, page_details, page_events, page_metadata, isLoading } = this.props;

    if (isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    let titleSection = <h2 key="page-name" className="list-header"><span key="page-name-inner" dangerouslySetInnerHTML={{ __html: page_details.name }} /></h2>;

    let lastUpdated;

    if(has(page_metadata, 'last_modified')) {
      if(page_metadata.last_modified) {
        lastUpdated = moment(page_metadata.last_modified, 'X').format('(ddd) MMM Do, YYYY @ h:mm a');
      }
    }

    let subscribe_url;

    if(has(page_metadata, 'subscribe_url')) {
      if(page_metadata.subscribe_url) {
        subscribe_url = page_metadata.subscribe_url;
      }
    }

    let featuredImageBackgroundStyle = {};

    if(has(page_details, 'featured_image_id')) {
      if (page_details.featured_image_id && page_details.featured_image_id.length > 0) {
        featuredImageBackgroundStyle.backgroundImage = `url('${window.API_ROOT}?type=export&action=image&export_type=db_thumb&id=${page_details.featured_image_id}')`;
        featuredImageBackgroundStyle.backgroundPositionX = 'center';
        featuredImageBackgroundStyle.backgroundPositionY = 'center';

        //<a target="_blank" href={`${window.API_ROOT}?type=export&action=image&export_type=db_image&id=${page_details.featured_image_id}`}></a>
      }
    }

    /*const sectionLabel = 'Share Page';
    const openModalButton = <a className="clickable">Add {sectionLabel} <Icon icon="arrow" className="link-indicator" style={{ marginTop: 0 }} /></a>;
    const searchIcon = this.state.showSearch
      ? (<a className="clickable" onClick={() => this.toggleSearch()}>Cancel</a>)
      : (<Icon icon="search" size="medium" clickable onClick={() => this.toggleSearch()} />);

        <Modal
          openByClickOn={openModalButton}
          rightAction={searchIcon}
          title={sectionLabel}
        >
          <a href="mailto:?body=">Email</a>
        </Modal>
      */

    return (
      <section className="page-page">
        {page_details.featured_image_id && page_details.featured_image_id.length > 0 && (
          <div key="page-featured-image-background-container">
            <div key="page-featured-image-background" className="page-featured-image-background" style={featuredImageBackgroundStyle}>
            </div>
          </div>
        )}
        {titleSection}
        {lastUpdated && (
          <div key="page-last-updated" className="page-last-updated">Last Updated: {lastUpdated}</div>
        )}
        <EventList
          events={page_events}
          subscribeUrl={subscribe_url}
          isLoading={isLoading}
          renderItem={this.renderEventListItem}
        />
      </section>
    );
  }
}

function mapStateToProps(state) {
  const { page_id } = state.router.params;
  const { page } = state;
  const { page_details, page_events, page_metadata } = page;

  const isLoading = !has(page_details, 'id') && !has(page_details, 'isError');

  return {
    page_id,
    page_details,
    page_events,
    page_metadata,
    isLoading,
  };
}

export default connect(mapStateToProps, {
  setHeader,
  loadPageView,
  push,
})(PageViewPage);



// WEBPACK FOOTER //
// ./src/app/containers/PageViewPage.js